import { load } from '@cashfreepayments/cashfree-js';

let cashfreePromise = null;

function resolveCashfreeMode() {
  const override = process.env.REACT_APP_CASHFREE_MODE;
  if (override === 'sandbox' || override === 'production') return override;
  return 'production';
}

/** Cashfree Element SDK for DA/CW collection QR (production by default). */
export async function loadCashfreeSdk() {
  if (typeof window === 'undefined') {
    throw new Error('Cashfree requires browser');
  }
  const mode = resolveCashfreeMode();
  if (!cashfreePromise) {
    cashfreePromise = load({ mode });
  }
  const cf = await cashfreePromise;
  if (!cf) throw new Error('Cashfree failed to load');
  return cf;
}

/** Fire-and-forget SDK preload — call early so QR mounts faster. */
export function warmCashfreeSdk() {
  try {
    loadCashfreeSdk().catch(() => {});
  } catch {
    /* ignore */
  }
}
